/**
 * List Schema of AlertaCarga
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {AlertaCarga} from '@/model/resource/AlertaCarga'

/* TODO: review generated schema */
export class ListAlertaCargaSchema extends Schema {
  readonly name = 'ListAlertaCarga'

  readonly fieldSet: FieldSet<AlertaCarga> = {
    idAlertaCargaPk: (): FieldComponent => ({
      is: Component.Render,
    }),
    alerta: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.alerta?.$id,
      },
    }),
    carga: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.carga?.$id,
      },
    }),
    motorista: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.motorista?.$id,
      },
    }),
    dataAlerta: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.datetime(schema.model.dataAlerta),
      },
    }),
  }
}
